import React, { useState, useRef, useMemo } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q5: '{q4} = 3',
    q6: '{q4} = 2',
    q7: '{q4} = 4',
    q8: '{q4} = 8',
    q9: '{q4} = 14',
    q10: '{q4} = 15',
    q11: '{q4} = 0',
    q12: '{q4} = 6',
    q13: '{q4} = 7',
    q14: '{q4} = 9',
    q15: '{q4} = 10',
    q16: '{q4} = 11',
    q17: '{q4} = 12',
    q18: '{q4} = 16',
    q19: '{q4} = 18',
    q20: '{q4} = 17',
    q21: '{q4} = 21',
    q22: '{q4} = 1',
    q23: '{q4} = 5',
    q24: '{q4} = 13',
    q25: '{q4} = 19',
    q26: '{q4} = 20',
    q30: '{q29} anyof [0]',
    q43: '{q42} = 0 or {q42} = 1 or {q42} = 2 or {q42} = 3 or {q42} = 4 or {q42} = 5 or {q42} = 6 or {q42} = 7 or {q42} = "other"',
    q48: '{q47} = 0 or {q47} = 1 or {q47} = 2 or {q47} = 3 or {q47} = 4 or {q47} = 5 or {q47} = 6 or {q47} = 7 or {q47} = 8 or {q47} = 9 or {q47} = 10 or {q47} = 11 or {q47} = "other"',
    q52: '{q51} = 0',
    q53: '{q51} = 0',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression:
        '({q0} = 1) or ({q1} = 1) or ({q2} = 0) or ({q2} = 1) or ({q2} = 2) or ({q2} = 3) or ({q2} = 4) or ({q2} = 5) or ({q2} = 6) or ({q2} = 7) or ({q2} = 8) or ({q2} = 9) or ({q2} = 10) or ({q2} = 11) or ({q2} = 12) or ({q2} = 13) or ({q2} = 14) or ({q2} = 15) or ({q2} = 16) or ({q2} = 17) or ({q2} = 18) or ({q2} = 19) or ({q2} = 20) or ({q2} = 21) or ({q2} = 22) or ({q2} = 23) or ({q2} = 24) or ({q2} = 25) or ({q2} = 26) or ({q2} = 27) or ({q2} = 28) or ({q2} = 29) or ({q2} = 30) or ({q2} = 31) or ({q2} = 32) or ({q2} = 33) or ({q2} = 34) or ({q2} = 35) or ({q2} = 36) or ({q2} = 37) or ({q2} = 38) or ({q2} = 39) or ({q2} = 40) or ({q2} = 41)',
      //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])
  const endMessage = `很抱歉，目前與您相同特性的樣本已經額滿，沒辦法參與本次活動。歡迎您分享本問卷連結給其他親朋好友，或加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    const q2value = survey.getValue('q2')
    if (
      survey.getValue('q0') === 1 ||
      survey.getValue('q1') === 1 ||
      (q2value >= 0 && q2value <= 41)
    ) {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<h4 style='text-align: center'>問卷已成功送出</h4><h4 style='text-align: center'>請按「完成」前往下載 EZChoice 或填寫更多問卷</h4>`
      )
    }
  }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
